import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { ApiResponse } from '../models/api-response';
import { Category } from '../models/category';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Pagination } from '../models/pagination';
import { HttpHeaders } from '@angular/common/http';
import { List } from '../models/list';

@Injectable({
  providedIn: 'root'
})
export class CategoryService {

  endpoint: string;

  constructor(private baseService: BaseService) {
    this.endpoint = 'categories';
  }

  public getAll(pagination?: Pagination): Observable<ApiResponse<List<Category>>> {
    return this.baseService.getAll<List<Category>>(this.endpoint, { params: <{}>pagination })
    .pipe(map(data => {
      data.payload.elements.forEach(e => {
        if (!e.id) {
          e.id = e._id;
          delete e._id;
        }
        if (!!e.parentCategory && !e.parentCategory.id) {
          e.parentCategory.id = e.parentCategory._id;
          delete e.parentCategory._id;
        }

        if (!!e.responsibles) {
          e.responsibles.forEach(r => {
            if (!r.id) {
              r.id = r._id;
              delete r._id;
            }
          });
        }
      });
      return data;
    }));
  }

  public get(id: string): Observable<ApiResponse<Category>> {
    return this.baseService.get<Category>(`${this.endpoint}/${id}`);
  }

  public add(category: Category): Observable<ApiResponse<Category>> {
    return this.baseService.add<Category>(this.endpoint, category);
  }

  public update(id: string, category: Category): Observable<ApiResponse<Category>> {
    return this.baseService.update<Category>(`${this.endpoint}/${id}`, category);
  }

  public delete(id: string): Observable<ApiResponse<Category>> {
    return this.baseService.delete<Category>(`${this.endpoint}/${id}`);
  }

  public show(id: string): Observable<ApiResponse<Category>> {
    return this.baseService.add<Category>(`${this.endpoint}/${id}/show`);
  }

  public hide(id: string): Observable<ApiResponse<Category>> {
    return this.baseService.add<Category>(`${this.endpoint}/${id}/hide`);
  }

  public updateIcon(id: string, icon: File): Observable<ApiResponse<Category>> {
    let formData: FormData = new FormData();
    formData.append('image', icon, icon.name);
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');
    return this.baseService.add<Category>(`${this.endpoint}/${id}/icon`, formData, headers);
  }

}
